import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Link } from 'components/ui';
import Location from 'utils/Location';
import urlUtils from 'utils/Url';
import helpersUtils from 'utils/Helpers';
import sysUtils from 'utils/ShopYourStore';

const { deferTaskExecution } = helpersUtils;

function CategoryList({ categories, setNextPageData, ...props }) {
    const handleOnClick = (e, displayName, targetUrl) => {
        e.preventDefault();
        deferTaskExecution(() => {
            setNextPageData(displayName);
            Location.navigateTo(e, targetUrl);
        });
    };

    return (
        <Box
            is='ul'
            lineHeight='tight'
            marginTop='-.5em'
            marginBottom={5}
            {...props}
        >
            {categories.map(category => {
                const { isSelected, targetUrl, displayName, recordCount } = category;
                const href = sysUtils.persistRefinementsInUrl(urlUtils.getLink(targetUrl));

                return (
                    <li key={`categoryListItem_${displayName}`}>
                        <Link
                            display='block'
                            paddingY='.5em'
                            fontWeight={isSelected && 'bold'}
                            href={href}
                            onClick={e => handleOnClick(e, displayName, href)}
                            children={`${displayName}${recordCount ? ` (${recordCount})` : ''}`}
                        />
                    </li>
                );
            })}
        </Box>
    );
}

export default wrapFunctionalComponent(CategoryList, 'CategoryList');
